import $ from 'jquery';
import Hammer from 'hammerjs';

class PostContentMiniCarousel {
  constructor(element) {
    this.$element = $(element);
    this.$list = this.$element.find('.post-content-mini-carousel__carousel-list');

    this.addListeners();
  }

  addListeners() {
    this.addTouchEvents();
  }

  addTouchEvents() {
    const hammertime = new Hammer(this.$element[0], {direction: Hammer.DIRECTION_HORIZONTAL});
    let translateXValue = 0;

    hammertime.on('pan', (event) => {
      this.$list.css({'transform': 'translateX(' + this.numberInRange(translateXValue + event.deltaX) + 'px)',});
    });

    hammertime.on('panend', (event) => {
      translateXValue += event.deltaX;
      this.$list.css({'transform': 'translateX(' + this.numberInRange(translateXValue) + 'px)',});
    });
  }

  numberInRange(number) {
    return Math.min(Math.max(number, this.$list.outerWidth() * -1), 0);
  };
}

$('.post-content-mini-carousel').each(function (index, element) {
  new PostContentMiniCarousel(element);
});
